import React from 'react';
import cx from 'classnames';

const Spinner = ({ className, size = 'm', color, ...props }) => (
  <div className={cx("g-spinner", className, size, color)} {...props} />
)
export default Spinner;